<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-list-check-2 me-1 text-primary"></i>Evaluation Report
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select appraisal."
                                        placement="top" container="body">
                                        <i class='bx bxs-calendar-event'></i>
                                    </span>
                                    <select id="filter" class="form-select border-start-0"
                                        [ngClass]="{'no-event': isLoading}" [(ngModel)]="activeAppraisalId">
                                        <option *ngFor="let appraisal of appraisals" [ngValue]="appraisal.id">{{ getTruncatedName(appraisal?.label ?? '', 10) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary">
                                        <i class="bx bx-bar-chart-alt-2"></i>
                                    </span>
                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name" placeholder="Select Hike" id="hike"
                                        [(ngModel)]="applicable" [clearable]="true" [searchable]="false">
                                        <ng-option value="true">Yes</ng-option>
                                        <ng-option value="false">No</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name" [(ngModel)]="promotable" id="promotable"
                                        placeholder="Select Promotable" [clearable]="true" [searchable]="false">
                                        <ng-option value="true">Yes</ng-option>
                                        <ng-option value="false">No</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name" [(ngModel)]="evaluation" id="evaluation"
                                        placeholder="Select Approved" [clearable]="true" [searchable]="false">
                                        <ng-option value="true">Yes</ng-option>
                                        <ng-option value="false">No</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-1 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class=" btn btn-secondary btn-sm " (click)="onStatusChange()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Employee</th>
                                    <th scope="col" width="200">Emp Code</th>
                                    <th scope="col" width="300">Self Rating</th>
                                    <th scope="col" width="250">L1 Rating</th>
                                    <th scope="col" width="300">Status</th>
                                    <th scope="col" width="300">Comments</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let approval of approvals | search : 'label' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{approval.assessmentDto?.appraiseeName}}</td>
                                    <td>{{approval.assessmentDto?.empCode}}</td>
                                    <td>{{approval.assessmentDto?.selfRating}}</td>
                                    <td>{{approval.assessmentDto?.loneRating}}</td>
                                    <td>{{approval.assessmentDto?.status}}</td>
                                    <td>{{approval.evaluationDto?.comments}}</td>
                                    <td class="actions">
                                        <button type="button" class="btn approve-btn btn-sm" [ngClass]="{'no-event':approval?.inProgress,'not-allowed':!privilege.canEdit, 
                                           'btn-outline-info': !approval?.active, 
                                           'btn-outline-success': approval?.active }"
                                            [ngbTooltip]="!privilege.canEdit ? 
                                               'You need permissions for this action. Required permission(s): setup.approval.edit' : 'Evaluation Report'"
                                            (click)="processPayment(approval)">
                                            <ng-container>
                                                <i class="bx bx-show"></i>
                                                View
                                            </ng-container>
                                        </button>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="10">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="approvals && approvals.length < 1; else noSearchResults">
                                            <td colspan="10">No evaluation reports were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="10"
                                                *ngIf="searchKeyword && (approvals | search : 'name' : searchKeyword).length == 0">
                                                No evaluation reports were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>